import ProductStatusCircle from "../../../UIElements/ProductStatusCircle";
import useApi from "../../../../Utils/BackendClient";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";

const Users = () => {

    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);

    const { changeUserStatus, fetchUsersList } = useApi();

    const [users, setUsers] = useState([]);
    const [reloadData, setReloadData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "is_active",
        sortOrder: 1,
    });

    useEffect(() => {
        if (location.state !== null) {
            toast.current.show(location.state.toast);
        }
        location.state = null;
    }, [location.state, location]);


    useEffect(() => {

        const fetchData = async () => {

            const response = await fetchUsersList(lazyState);

            if (response.status !== 200) {
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку", detail: "Помилка сервера " + response.status, life: 3000 });
                setTotalRecords(0);
                setUsers([]);
            }
            else {

                setTotalRecords(response.data.count);
                setUsers(response.data.results);
            }

            setLoading(false);
        }

        fetchData();

    }, [reloadData, lazyState, fetchUsersList]);

    const ChangeUserStatusHandler = async (rowData) => {

        const action = rowData.is_active ? "deactivate_user" : "activate_user";

        const response = await changeUserStatus(rowData.id, action);

        if (response.status !== 200) {
            toast.current.show({ severity: "error", summary: "Помилка зміни статусу", detail: "Помилка сервера " + response.status, life: 3000 });
        }
        else {
            toast.current.show({ severity: 'success', summary: rowData.is_active ? 'Деактивація' : "Активація", detail: rowData.is_active ? 'Користувача деактивовано' : "Користувача активовано", life: 3000 });
        }

        setReloadData(!reloadData);
    }

    const CreateNewUserButtonHandler = () => {
        navigate('/users/newuser');
    };

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const changeStatus = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: rowData.is_active ? 'Підтвердження деактивації користувача' : 'Підтвердження активації користувача',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { ChangeUserStatusHandler(rowData) }
        });
    }

    const EditButtonHandler = (rowData) => {

        const route = '/users/edituser/' + rowData.id;
        navigate(route, { state: { id: rowData.id } });
    }

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Додати користувача" severity="success" className={commonStyle.addButton} onClick={CreateNewUserButtonHandler} />
        </div>)
    }

    const images = require.context('../../../../images', true);

    const getPicture = pictureName => {

        let path = './Random_user_pic.png';

        if (pictureName !== null) {
            path = './' + pictureName;
        }

        return images(path);
    }

    const userBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center gap-2">
                <img alt={rowData.full_name} src={getPicture(null)} style={{ borderRadius: "50%" }} width="32" />
                <span>{rowData.full_name}</span>
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                size="small"
                icon={rowData.is_active ? "pi pi-times" : "pi pi-check"}
                className={`p-button-rounded ${rowData.is_active ? commonStyle.deleteButton + " p-button-danger" : commonStyle.addButton + " p-button-success"}`}
                tooltip={rowData.is_active ? "Деактивувати" : "Активувати"}
                tooltipOptions={{ position: "top"}}
                onClick={(event) => changeStatus(event, rowData)}
            />
            <Button
                size="small"
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                tooltip="Редагувати"
                tooltipOptions={{ position: "left"}}
                onClick={() => EditButtonHandler(rowData)}
            />
        </div>
        );
    };

    const mobileRowBody = rowData => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-2 flex justify-content-center align-items-center">
                        <ProductStatusCircle id={rowData.id} type="statusCircle" isActive={rowData.is_active}/>
                    </div>
                    <div className="col-10">
                        <div className="flex-column">
                            <div className="font-bold"><i className="pi pi-user"/> {rowData.full_name}</div>
                            <div><i className="pi pi-briefcase"/> {rowData.employee_position === "" ? "Посаду не вказано" : rowData.employee_position}</div>
                            <div><i className="pi pi-at"/> {rowData.email === "" ? "Email не вказано" : rowData.email}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (<>
        <Toast ref={toast} />
        <Toolbar end={toolbarRightTemplate} />
        
        <div className='grid'>
             <div className='col-12 justify-content-center'>
                {!isMobile &&<DataTable value={users} lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 20]} tableStyle={{ minWidth: '60rem' }} >
                    <Column field="full_name" header="Користувач" body={userBodyTemplate} />
                    <Column field="employee_position" header="Посада" />
                    <Column field="division_name" header="Точка продажу" />
                    <Column field="email" header="Email" sortable />
                    <Column field="is_active" header="Статус" body={rowData => <ProductStatusCircle id={rowData.id} type="statusCircle" isActive={rowData.is_active} />} sortable />
                    <Column field="action" body={actionBodyTemplate} />
                </DataTable>}
                {isMobile && <DataTable value={users} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} 
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" dataKey="id" emptyMessage="Клієнтів не знайдено" >
                    <Column field="id" headerStyle={{ display: 'none' }} body={mobileRowBody} />
                </DataTable>}
            </div>
            <ConfirmPopup group="headless" />
        </div>
    </>)
}

export default Users;